import { DEFAULT_WORKING_HOURS } from "@/lib/const";
import { WorkingDay, WorkingHours } from "@/types/v2";

/**
 * Returns a fresh WorkingHours with `key` set to `value` on every day.
 * Never mutates `current`, DEFAULT_WORKING_HOURS, or their nested day objects.
 */
export const buildWorkingHours = (
  current: WorkingHours | undefined,
  key: keyof Omit<WorkingDay, "isClosed">,
  value: string
): WorkingHours => {
  const base = { ...DEFAULT_WORKING_HOURS, ...current };
  return Object.fromEntries(
    Object.entries(base).map(([day, dayValue]) => [
      day,
      { ...dayValue, [key]: value },
    ])
  ) as WorkingHours;
};
